import request from '@/services/interceptor.js'


export const get_offerte = (par) => {
  return request({
      url: '/api/offerte',
      method: 'get',
  })
};

export const get_offerteCarousel = (par) => {
  return request({
      url: '/api/offerte/carousel',
      method: 'get',
  })
};
